export const REQUEST_OPEN_MODAL = 'REQUEST_OPEN_MODAL';
export const REQUEST_CLOSE_MODAL = 'REQUEST_CLOSE_MODAL';
